import { Link } from "react-router-dom";

import { Box, Inline, useBreakpoint } from "@seneca/senekit";

import TeacherLogo from "features/common/logos/TeacherLogo";
import { linkToTeacherHomepage } from "features/teachers/links";

import useShouldHideTeacherNavBar from "../../hooks/useShouldHideTeacherNavBar";
import TeacherNavbarDesktop from "./TeacherNavbarDesktop";
import TeacherNavbarMobile from "./TeacherNavbarMobile";

export default function TeacherNavbar() {
  const { isMobileOrTablet } = useBreakpoint();
  const shouldHide = useShouldHideTeacherNavBar();

  if (shouldHide) return null;

  return (
    <Box marginX={["large", "xlarge"]} marginY="xlarge" dataTest="Navbar">
      <Inline
        flexWrap="nowrap"
        justifyContent="space-between"
        alignItems="center"
      >
        <Link to={linkToTeacherHomepage()} style={{ textDecoration: "none" }}>
          <TeacherLogo />
        </Link>

        {isMobileOrTablet ? <TeacherNavbarMobile /> : <TeacherNavbarDesktop />}
      </Inline>
    </Box>
  );
}
